import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

const useStyles = makeStyles<void, 'rating' | 'label' | 'small' | 'shapeIcon'>({
	uniqId: 'ratingbox',
	name: 'rating-box',
})((theme, _params, classes) => ({
	container: {
		margin: 0,
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.xxsmall,
	},
	shapeIcon: {
		position: 'absolute',
		width: '100%',
		height: '100%',
	},
	ratingValue: {
		position: 'absolute',
		zIndex: 1,
	},
	rating: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		letterSpacing: '-0.5px',
		position: 'relative',
		fontWeight: theme.weight.bold,
		fontSize: theme.fontSize.small,
		color: theme.userScore.foreground.color.default,
	},
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.micro,
		overflow: 'hidden',
		[`&.${classes.small}`]: {
			flexWrap: 'wrap',
			alignItems: 'center',
			flexDirection: 'row',
			gap: theme.spacing.tiny,
		},
	},
	label: {
		font: theme.userScore.label.xSmall,
	},
	darkGreen: {
		[`&.${classes.rating}`]: {
			[`& .${classes.shapeIcon}`]: {
				fill: theme.userScore.color.great,
				width: '100%',
			},
		},
		[`&.${classes.label}`]: {
			color: theme.userScore.color.great,
		},
	},
	green: {
		[`&.${classes.rating}`]: {
			[`& .${classes.shapeIcon}`]: {
				fill: theme.userScore.color.good,
				width: '100%',
			},
		},
		[`&.${classes.label}`]: {
			color: theme.userScore.color.good,
		},
	},
	yellow: {
		[`&.${classes.rating}`]: {
			color: theme.userScore.foreground.color.mediocre,

			[`& .${classes.shapeIcon}`]: {
				fill: theme.userScore.color.mediocre,
				width: '100%',
			},
		},
		[`&.${classes.label}`]: {
			color: theme.userScore.foreground.color.mediocre,
		},
	},
	red: {
		[`&.${classes.rating}`]: {
			[`& .${classes.shapeIcon}`]: {
				fill: theme.userScore.color.bad,
				width: '100%',
			},
		},
		[`&.${classes.label}`]: {
			color: theme.userScore.color.bad,
		},
	},
	gray: {
		[`&.${classes.rating}`]: {
			color: theme.userScore.foreground.color.none,

			[`& .${classes.shapeIcon}`]: {
				fill: theme.userScore.color.none,
				width: '100%',
			},
		},
		[`&.${classes.label}`]: {
			color: theme.userScore.foreground.color.none,
		},
	},
	xSmall: {
		[`&.${classes.rating}`]: {
			font: theme.userScore.label.xSmall,
			height: theme.score.size.xsmall,
			width: theme.score.size.xsmall,
			minWidth: theme.score.size.xsmall,
		},
	},
	small: {
		[`&.${classes.rating}`]: {
			font: theme.userScore.label.xSmall,
			height: theme.score.size.small,
			width: theme.score.size.small,
			minWidth: theme.score.size.small,
		},
	},
	medium: {
		[`&.${classes.rating}`]: {
			font: theme.userScore.label.medium,
			height: theme.score.size.medium,
			width: theme.score.size.medium,
			minWidth: theme.score.size.medium,
		},
	},
	large: {
		[`&.${classes.rating}`]: {
			font: theme.userScore.label.large,
			height: theme.score.size.large,
			width: theme.score.size.large,
			minWidth: theme.score.size.large,
		},
	},
	jumbo: {
		[`&.${classes.rating}`]: {
			font: theme.userScore.label.jumbo,
			height: theme.score.size.jumbo,
			width: theme.score.size.jumbo,
			minWidth: theme.score.size.jumbo,
		},
	},
}));

export default useStyles;
